import { render } from "./Acc.vue?vue&type=template&id=184c80e5&scoped=true&ts=true"
import script from "./Acc.vue?vue&type=script&lang=ts"
export * from "./Acc.vue?vue&type=script&lang=ts"

import "./Acc.vue?vue&type=style&index=0&id=184c80e5&lang=scss&scoped=true"

import exportComponent from "/home/vaab/dev/js/monujo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184c80e5"]])

export default __exports__